import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import ApiService from "../../../ApiService";
import DispatchProps from "../../../../utils/DispatchProps";
import PageTitle from "../../../PageTitle";
import {IRootState} from "../../../../store";
import Table, {TableColumn} from "../../../Table";
import {Link} from "react-router-dom";
import {CommandBarButton, MessageBarType, TextField} from "office-ui-fabric-react";
import MultiSelectTable from "../../../MultiSelectTable";
import Actions from "../../../../redux/Actions";
import {
    IContainerImageTagOverridePatch
} from "../../../../models/container-image-tags/ISchoolContainerImageTagOverridePatch";

interface ContainerImagePageProps
{
    imageName: string;
    apiService: ApiService;
}

interface ContainerImagePageState
{
    defaultTag?: string;
    schoolTagOverrides?: any[];
    selectedSchoolTagOverrides: any[];
    loading: boolean;
    
    overrideTag: string;
    savingOverrides: boolean; 
    
}

const defaultColumns: TableColumn[] = [
    {title: "Image Name",propertyPath: "imageName",flex: 1},
    {title: "Default Tag",propertyPath: "defaultTag",flex: 1}
];

const overrideColumns: TableColumn[] = [
    {title: "Tenant Id",propertyPath: "tenantId",flex: 2} , 
    {title: "School Code",propertyPath: "schoolCode",flex: 2} , 
    {title: "Image Name",propertyPath: "imageName",flex: 2} , 
    {title: "Override Tag",propertyPath: "overrideTag",flex: 2} , 
];

class ContainerImagePage extends Component<ContainerImagePageProps & DispatchProps, ContainerImagePageState> {

    constructor(props: ContainerImagePageProps & DispatchProps) {
        super(props);

        this.state = {
            defaultTag: undefined,
            schoolTagOverrides: undefined,
            selectedSchoolTagOverrides: [],
            loading: false,
            
            overrideTag: "",
            savingOverrides: false
        };
    }

    async componentDidMount() {
        
        await this.loadDefaultAndOverrides();
    }

    async componentDidUpdate(prevProps: Readonly<ContainerImagePageProps & DispatchProps>, prevState: Readonly<ContainerImagePageState>, snapshot?: any): Promise<void>
    {

    }
    
    private loadDefaultAndOverrides = async () =>
    {
        this.setState({
            loading: true
        });
        const defaultTag = await this.props.apiService.getContainerImageTagDefault(this.props.imageName);
        const schoolTagOverrides = await this.props.apiService.getSchoolContainerImageTagOverrides(this.props.imageName);

        this.setState({
            defaultTag,
            schoolTagOverrides,
            selectedSchoolTagOverrides: [],
            loading: false
        });
    }
    
    private saveOverrides = async () => {
        
        if(this.state.selectedSchoolTagOverrides.length === 0)
        {
            return;
        }
        
        this.setState({
            savingOverrides: true
        });
        
        try
        {
            const patch: IContainerImageTagOverridePatch = {
                imageName: this.props.imageName,
                overrideTag: this.state.overrideTag === "" ? null : this.state.overrideTag,
                schools: this.state.selectedSchoolTagOverrides.map(sto => {
                    return {tenantId: sto.tenantId, schoolCode: sto.schoolCode};
                })
            }
            await this.props.apiService.patchSchoolContainerImageTagOverrides(this.props.imageName,patch);
            
            await this.props.dispatch(Actions.showMessageBar(`Successfully saved overrides`, MessageBarType.success));
            await this.loadDefaultAndOverrides();
            this.setState({
                overrideTag: ""
            })
        }
        catch (e)
        {
            await this.props.dispatch(Actions.showMessageBar(`Failed to save overrides ${e}`, MessageBarType.error));
        }
        finally
        {
            this.setState({
                savingOverrides: false
            })
        }
    }

    public render(): JSX.Element {
        
        return (
            <Fragment>
                <PageTitle title={this.props.imageName} />
                
                <Table
                    title={`Default tag for ${this.props.imageName}`}
                    columns={defaultColumns}
                    items={[
                        {
                            imageName: this.props.imageName,
                            defaultTag: this.state.defaultTag
                        }
                    ]}>
                    <Link to={`/cdb-admin/container-images/${this.props.imageName}/edit`}>
                        <CommandBarButton
                            iconProps={{iconName: "edit"}}
                            text="Edit"
                            onClick={() => {}}
                        />
                    </Link>
                </Table>
                
                
                <MultiSelectTable
                    columns={overrideColumns}
                    loading={this.state.loading}
                    items={this.state.schoolTagOverrides || []} 
                    selectedItems={this.state.selectedSchoolTagOverrides}
                    onSelectedItemsChanged={(newSelectedItems) => {
                        this.setState({
                            selectedSchoolTagOverrides: newSelectedItems
                        })
                    }}>
                    <div className={"flex-row  flex--align-items-center"}>
                        <TextField 
                            style={{width: "300px"}}
                            placeholder={"Override Tag (blank to delete)"}
                            value={this.state.overrideTag || ""}
                            onChange={(e,newValue) => {
                                this.setState({
                                    overrideTag: newValue!
                                });
                            }}
                        />
                        <CommandBarButton
                            disabled={this.state.loading || this.state.savingOverrides}
                            iconProps={{ iconName: "save" }}
                            text={`Save ${this.state.selectedSchoolTagOverrides.length} Overrides`}
                            onClick={this.saveOverrides}
                        />
                    </div>
                    
                </MultiSelectTable>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): ContainerImagePageProps => {
        return {
            imageName: ownProps.match.params[0],
            apiService: state.auth.apiService
        };
    }
)(ContainerImagePage)